import React from 'react'

import TabTitle from '@/components/misc/CompanyProfile/components/TabTitle'
import CompanyReviews from '@/components/misc/CompanyReviews/CompanyReviews'

interface Props {
  companyId: number
}

const ReviewsTab: React.FC<Props> = ({ companyId }) => (
  <>
    <CompanyReviews
      companyId={companyId}
      render={({ data, renderReviews }) => (
        <>
          <TabTitle>
            Reviews from professionals ({data['hydra:totalItems']})
          </TabTitle>

          {renderReviews()}
        </>
      )}
    />
  </>
)

export default ReviewsTab
